import React from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";

const ProductsGrid = ({
  products,
  purity,
  likedProducts,
  selectedProducts,
  onProductClick,
  onLikeClick,
  onSelectedClick,
  onResetFilters,
}) => {
  const navigate = useNavigate();
  console.log(products);
  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  const handleLikeClick = (e, productId) => {
    e.stopPropagation();
    onLikeClick(productId);
  };

  const handleSelectedClick = (e, product) => {
    e.stopPropagation();
    onSelectedClick(product);
  };

  const isProductLiked = (productId) => likedProducts.includes(productId);
  const isProductSelected = (productId) =>
    selectedProducts.some((p) => p.id === productId);

  if (products.length === 0) {
    return (
      <div className="no-products">
        <h3>No products found</h3>
        <p>Try adjusting your filters or check back later for new inventory.</p>
        <button onClick={onResetFilters} className="reset-filters">
          Reset All Filters
        </button>
      </div>
    );
  }

  return (
    <div className="catalog-grid">
      {products.map((product, index) => (
        <ProductCard
          key={`${product.id}-${index}`}
          product={product}
          purity={purity}
          isLiked={isProductLiked(product.id)}
          isSelected={isProductSelected(product.id)}
          onProductClick={handleProductClick}
          onLikeClick={handleLikeClick}
          onSelectedClick={handleSelectedClick}
        />
      ))}
    </div>
  );
};

export default ProductsGrid;
